import { Head, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import LocationForm from "./_form"

interface Customer {
  id: number
  display_name: string
}

interface Option {
  id: number
  name: string
}

interface LocationData {
  id: number
  name: string
  address: string
  address2: string
  city: string
  state: string
  zip: string
  phone: string
  fax: string
  email: string
  website: string
  notes: string
  sales_rep_id: number | null
}

interface Props {
  customer: Customer
  location: LocationData
  users: Option[]
  errors?: Record<string, string[]>
}

export default function Edit({ customer, location, users, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Customers", href: "/customers" },
    { title: customer.display_name, href: `/customers/${customer.id}` },
    { title: "Locations", href: `/customers/${customer.id}/locations` },
    {
      title: "Edit",
      href: `/customers/${customer.id}/locations/${location.id}/edit`,
    },
  ]

  const { data, setData, patch, processing, transform } = useForm({
    name: location.name || "",
    address: location.address || "",
    address2: location.address2 || "",
    city: location.city || "",
    state: location.state || "",
    zip: location.zip || "",
    phone: location.phone || "",
    fax: location.fax || "",
    email: location.email || "",
    website: location.website || "",
    notes: location.notes || "",
    sales_rep_id: location.sales_rep_id,
  })

  transform((data) => ({ location: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/customers/${customer.id}/locations/${location.id}`)
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit Location - ${customer.display_name}`} />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">Edit Location</h1>

        <LocationForm
          customerId={customer.id}
          data={data}
          setData={setData}
          errors={errors}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Update Location"
          users={users}
        />
      </div>
    </AppLayout>
  )
}
